<template>
  <div class="scd-route">
    <div v-if="detailList && detailList.length" class="scft-left">
      <div class="cgsllt-left">运单编号：</div>
      <div class="cgsllt-right">{{ waybillNo || '暂无' }}</div>
    </div>
    <div
      :class="['scdr-list', index === 0 && 'scdrl-resiver-bg']"
      v-for="(item, index) in detailList"
      :key="index"
    >
      <div v-if="index === 0 && exceptionToast" class="exception-status-red">
        物流异常提醒
      </div>
      <div
        v-else
        class="scdrl-left"
        :class="{'status-red': item.code == codeMap['EXPRESS_COLLECTION'] || item.code === codeMap['DELIVERY_OUT'] || item.code === codeMap['SEND_SCAN']}"
      >
        {{item.status}}
      </div>
      <!-- <div class="scdrl-left"
            v-if="item.operationTypeMiniEnum === 'SIGNED'">已签收</div>
      <div class="scdrl-left"
            v-else-if="item.operationTypeMiniEnum === 'DELIVERYED' || item.operationTypeMiniEnum === 'COLLECTION_BY_PROXY'">派件中</div>
      <div class="scdrl-left status-red"
            v-else-if="item.operationTypeMiniEnum === 'COLLECTED'">已揽件</div>
      <div class="scdrl-left status-orange"
            v-else-if="item.operationTypeMiniEnum === 'REJECTION'">已拒收</div>
      <div class="scdrl-left status-red"
            v-else>运送中</div> -->
      <div class="scdrl-center">
        <div
          class="scdrlc-text scdrllc-ab"
          v-if="index === 0 && exceptionToast">
        !
        </div>
        <div
          class="scdrlc-text scdrllc-ab"
          v-else-if="item.code === codeMap['SIGNING_SCAN'] || item.code === codeMap['PARTNER_SIGNING_SCAN']"
        >签</div>
        <div
          class="scdrlc-text scdrlc-send"
          v-else-if="item.code === codeMap['DELIVERY_OUT'] && item.status === '发往代理点'"
        >
          发
        </div>
        <div
          class="scdrlc-text scdrlc-send"
          v-else-if="item.code === codeMap['ALREADY_COLLECTED']"
        >
          代
        </div>
        <div
          class="scdrlc-text scdrlc-send"
          v-else-if="item.code === codeMap['DELIVERY_OUT']"
        >
          派
        </div>
        <div
          class="scdrlc-text scdrlc-send"
          v-else-if="item.code === codeMap['PARTNER_RECEIPT']"
        >
          派
        </div>
        <div
          class="scdrlc-text scdrllc-ab"
          v-else-if="item.code === codeMap['SEND_SCAN']"
        >发</div>
        <div
          class="scdrlc-text scdrl-null"
          v-else-if="item.code === codeMap['ABNORMAL_PIECE_SCAN']"
          style="background: #FA6400 !important;z-index:1;"
        ></div>
        <div v-else>
          <div
            v-if="index !== 0"
            class="scdrlc-text scdrl-null"
          ></div>
          <div
            v-else
            class="scdrl-center"
          >
            <div class="scdrlc-text scdrlc-send">运</div>
          </div>
        </div>
      </div>
      <div class="scdrl-right" v-if="bsFlag">
        <!-- 代理点收入扫描	 -->
        <span
          v-if="item.code === codeMap['COLLECTION_BY_PROXY']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 快件揽收 -->
        <span
          v-if="item.code === codeMap['EXPRESS_COLLECTION']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 快件入仓扫描 -->
        <span
          v-else-if="item.code === codeMap['RECEIPT']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 装车发件扫描 -->
        <span
          v-else-if="item.code === codeMap['SEND_SCAN']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 到件扫描 code为92 -> 3种状态：中心、集散点、网点-->
        <span
          v-else-if="item.code === codeMap['ARRIVAL_SCAN']"
          class="scdrlr-state"
        >
          {{item.customerTracking}}
        </span>
        <!-- 集货到件扫描 -->
        <span
          v-else-if="item.code === codeMap['STORE_SCAN']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 转运中心到件扫描-->
        <span
          v-else-if="item.code === codeMap['CENTER_SCAN']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 快件取出扫描  派件出仓-->
        <span
          v-else-if="item.code === codeMap['DELIVERY_OUT']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 重新派件 -->
        <span
          v-else-if="item.code === codeMap['PARTNER_DELIVERY_OUT']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 签收扫描 快件签收 -->
        <span
          v-else-if="item.code === codeMap['SIGNING_SCAN']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 已存入快递柜 入库扫描 200 -->
        <span
          v-else-if="item.code === codeMap['PARTNER_RECEIPT']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 取件码签收  -->
        <span
          v-else-if="item.code === codeMap['PARTNER_SIGNING_SCAN']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 问题件 已拒收 -->
        <span
          v-else-if="item.code === codeMap['ABNORMAL_PIECE_SCAN']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 航空件扫描 -->
        <span
          v-else-if="item.code === codeMap['AVIATION']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <!-- 申通物流 -->
        <span
          v-else-if="item.code === codeMap['SHENTONG']"
          class="scdrlr-state"
        >
          <span
            class="c-bold"
            v-if="item.customerTracking"
          >{{item.customerTracking}}</span>
        </span>
        <!-- 异常件 -->
        <span
          v-else-if="item.code === codeMap['ABNORMAL_ORDER']"
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <span
          v-else
          class="scdrlr-state"
        >
        {{item.customerTracking}}
        </span>
        <div class="scdrlr-time">{{item.scanTime}}</div>
      </div>
      <div class="scdrl-right" v-else>
        <!-- 代理点收入扫描	 -->
        <span
          class="scdrlr-state"
        >
          <span
              v-for="(son, sonIndex) in item.customerTrackingText"
              :key="sonIndex">
              <a v-if="son.type === 'phone'" class="c-blue" :href="`tel:${son.value}`">{{son.value}}</a>
              <span v-else>{{son.value}}</span>
            </span>
        </span>
        <div class="scdrlr-time">{{item.scanTime || ''}}</div>
      </div>
      <!-- <div
        class="scdr-img"
        @click="previewImage(item.electronicSignaturePicUrl)"
        v-if="item.electronicSignaturePicUrl"
      >
        <img
          class="scdri-img"
          :src="item.electronicSignaturePicUrl"
        >
      </div> -->
    </div>
  </div>
</template>

<script>
const codeMap = {
  EXPRESS_COLLECTION: 10, // 已揽件， 快件揽收
  RECEIPT: 20, // 已揽件，  入仓扫描
  SEND_SCAN: 50, // 装车发件扫描
  COLLECTION_BY_PROXY: 202, // 代理点收入扫描
  ARRIVAL_SCAN: 92, //  到件扫描 code为92 -> 3种状态：中心、集散点、网点
  STORE_SCAN: 91, // 集货到件
  PARTNER_DELIVERY_OUT: 201, // 派件中，快件取出扫描
  CENTER_SCAN: 90, // 转运中心到件扫描
  DELIVERY_OUT: 94, // 派件中，  出仓扫描
  SIGNING_SCAN: 100, // 签收扫描 快件签收
  PARTNER_RECEIPT: 200, // 派件中，扫描入库
  PARTNER_SIGNING_SCAN: 300, // 已签收 ，出库扫描
  ABNORMAL_PIECE_SCAN: 110, // 问题件，已拒收
  AVIATION: 41, // 航空件扫描
  ABNORMAL_ORDER: 130, // 订单异常
  SHENTONG: 450, // 申通物流
  ALREADY_COLLECTED: 200, // 已代收
}

export default {
  props: {
    routeList: {
      type: Array,
      default() {
        return []
      },
    },
    waybillNo: {
      type: [String || Number],
    },
    bsFlag: {
      type: Boolean,
      default: false, // 百世件 默认为非百世件
    },
    exceptionToast: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      codeMap,
      detailList: [],
    }
  },
  watch: {
    routeList: {
      deep: true,
      handler(val) {
        console.log(val)
        let trackList = val
        // 如果有异常轨迹信息，则将异常轨迹信息放在第一条
        if (this.exceptionToast) {
          const exceptionToastArr = [{
            customerTracking: this.exceptionToast,
          }]
          trackList = [...exceptionToastArr, ...trackList]
        }
        trackList.forEach((item, index) => {
          item.customerTrackingText = this.selectPhoneNumber(item.customerTracking)
        })
        this.detailList = trackList
      },
    },
  },
  methods: {
    selectPhoneNumber(str) {
      if (!str) return ''
      const regx = /(1[3|4|5|6|7|8|9][\d]{9}|0[\d]{2,3}-[\d]{6,8}|400[-]?[\d]{3}[-]?[\d]{4}|(0|[2-9])\d{5,12})/g
      const phoneNums = str.match(regx)
      if (phoneNums) {
        for (let i = 0; i < phoneNums.length; i++) {
          const temp = phoneNums[i]
          str = str.replace(phoneNums[i], `@@@${temp}@@@`)
        }
      }
      return str.split('@@@').map(item => {
        return { type: item.match(regx) ? 'phone' : 'string', value: item }
      })
    },
    // call(phoneNumber) {
    //   wx.makePhoneCall({ phoneNumber })
    // },
  },
}
</script>

<style lang="scss" scoped>
$color999: #999999;
.scd-route {
  margin-top: 20rpx;
  background: #ffffff;
  padding: 20rpx 30rpx;
  box-sizing: border-box;
  min-height: 14.3vh;
  .scdr-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 90rpx;
    position: relative;
    .scdr-img {
      position: absolute;
      bottom: 0;
      left: 80px;
      .scdri-img {
        width: 35px;
        height: 35px;
        // background: red;
      }
    }
    &:last-child {
      .scdrl-center {
        // width: 70rpx;
        &::after {
          height: 0 !important;
        }
      }
    }
    .scdrl-left {
      color: $color999;
      font-weight: bolder;
      font-size: 24rpx;
      width: 80rpx;
    }
    .scdrl-center {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .scdrlc-text {
        line-height: 1;
        font-size: 18rpx;
        border-radius: 50%;
        width: 30rpx;
        height: 30rpx;
        background: #d8d8d8;
        margin: 0 20rpx;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 998;
      }

      &::after {
        position: absolute;
        content: '';
        height: 100%;
        width: 2rpx;
        background: #d8d8d8;
        top: 50rpx;
        left: 108rpx;
      }
    }
    .scdrl-null {
      width: 14rpx !important;
      height: 14rpx !important;
    }
    .scdrl-right {
      width: 550rpx;
      word-break: break-all;
      .scdrlr-time {
        font-size: 22rpx;
        color: #999;
      }
      .scdrlr-state {
        padding-bottom: 4rpx;
        color: #3c3c3c;
        font-size: 24rpx;
        line-height: 30rpx;
        .c-blue {
          color: #2779ff;
        }
        .c-bold {
          font-weight: bold;
        }
        .special-text {
          margin-left: 10rpx;
          color: #e60012;
        }
      }
    }
  }
  .scdrl-resiver-bg {
    .scdrl-left {
      color: #2779ff;
    }
    .exception-status-red {
      width: 72rpx;
      font-size: 24rpx;
      font-weight: 700;
      text-align: left;
      color: #e6262c;
      line-height: 27rpx;
    }
    .status-red {
      color: #e6262c;
    }
    .status-orange {
      color: #fa6400;
    }
    .scdrlc-text {
      background: #2779ff !important;
      color: #ffffff;
      position: absolute;
      z-index: 1;
      left: 82rpx;
      &::before {
        content: '';
        position: absolute;
        left: 12rpx;
        width: 6rpx;
        height: 60rpx;
        background: #fff;
        display: block;
        top: -60rpx;
      }
    }
    .scdrllc-ab,
    .scdrlc-send {
      background: #e60012 !important;
      color: #fff;
      left: 74rpx !important;
    }
  }
}

.scft-left {
  font-size: 28rpx;
  display: flex;
  align-items: center;
  margin-bottom: 30rpx;

  .cgsllt-left {
    color: $color999;
  }

  .cgsllt-right {
    color: #333333;
  }

  .cgsllt-img {
    width: 24rpx;
    height: 24rpx;
    margin-left: 10rpx;
  }
}
</style>
